import React from 'react';

// Evita la "pantalla en blanco": si un componente hijo lanza un error al renderizar,
// muestra un mensaje amable con la opción de reintentar en lugar de dejar todo blanco.
export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('ErrorBoundary atrapó un error de render:', error, info);
  }

  handleReload = () => {
    this.setState({ hasError: false });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6" data-testid="error-boundary">
          <div className="max-w-md w-full bg-white rounded-lg border border-slate-200 shadow-sm p-6 text-center">
            <h1 className="text-lg font-semibold text-slate-900">Ocurrió un problema al mostrar esta pantalla</h1>
            <p className="text-sm text-slate-500 mt-2">
              Reintentá en unos segundos. Si sigue pasando, avisanos y lo revisamos.
            </p>
            <button
              onClick={this.handleReload}
              className="mt-4 inline-flex items-center justify-center rounded-md bg-[#1B4D3E] px-4 py-2 text-sm font-medium text-white hover:bg-[#163d32]"
              data-testid="error-boundary-reload"
            >
              Reintentar
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
